import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton, Tooltip, Typography } from '@mui/material';

export function normalizeFieldInfoContent(content: React.ReactNode) {
  if (typeof content === 'string') {
    return (
      <Typography variant="captionText" sx={{ whiteSpace: 'pre-line' }}>
        {content}
      </Typography>
    );
  }

  return content;
}

export function FieldInfoIcon({ title }: { title: React.ReactNode }) {
  return (
    <Tooltip title={normalizeFieldInfoContent(title)} arrow>
      <IconButton size="small" tabIndex={-1}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
